module.exports = __webpack_public_path__ + "static/img/p1.5ecd014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/photo/p1.jpg
// module id = Mc8e
// module chunks = 1